import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarAction,
  MatSnackBarActions,
  MatSnackBarLabel,
  MatSnackBarRef,
} from '@angular/material/snack-bar';
import { MatButtonModule } from '@angular/material/button';
import { extractUrl, splitAndRemoveUrl } from '@res/ng-shared';
import { CapitalizePipe } from '@res/ng-capitalize';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatSnackBarLabel,
    MatSnackBarActions,
    MatSnackBarAction,
    CapitalizePipe,
    TranslocoPipe,
  ],
  selector: 'lib-missing-firebase-index',
  templateUrl: './missing-firebase-index.component.html',
  styleUrl: './missing-firebase-index.component.scss',
})
export class MissingFirebaseIndexComponent {
  snackBarRef: MatSnackBarRef<MissingFirebaseIndexComponent> = inject(MatSnackBarRef<MissingFirebaseIndexComponent>);
  snackBarData = inject(MAT_SNACK_BAR_DATA);

  get message() {
    return splitAndRemoveUrl(this.snackBarData.message).join(' ');
  }
  get url() {
    return extractUrl(this.snackBarData.message) || '';
  }
  onNavigate() {
    window.open(this.url, '_blank');
    this.snackBarRef.dismiss();
  }
}
